<template>
    <detail-bootcamp-mobile v-if="isMobile" />
    <detail-bootcamp-dekstop v-else />
</template>

<script>
import DetailBootcampDekstop from '@/components/bootcamp/desktop/DetailBootcamp.vue';
import DetailBootcampMobile from '@/components/bootcamp/mobile/DetailBootcamp.vue';

export default {
    name: "DetailClassBootcamp",
    components: {
        DetailBootcampDekstop,
        DetailBootcampMobile
    },
    data() {
    return{
      isMobile: false
    }
  },
  methods: {
      handleView() {
          this.isMobile = window.innerWidth <= 990
      }
  },
  mounted() {
    this.$gtag.pageview(this.$route)
    this.$utils.scrollTop()
  },
  beforeMount() {
      this.handleView()
      sessionStorage.setItem('nav-item-active', 0)
  },
}
</script>